module.exports = __webpack_public_path__ + "img/image2.0638df83.png";